/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-verfuegbarkeit-info/shop.artikel-verfuegbarkeit-info.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Verfuegbarkeitsanfrage} from '../../models/verfuegbarkeitsanfrage';

/**
 * Zweck: Beschreibt class ShopArtikelVerfuegbarkeitInfoComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.artikel-verfuegbarkeit-info.component.html',
    styleUrls: ['shop.artikel-verfuegbarkeit-info.component.scss'],
    standalone: false
})
export class ShopArtikelVerfuegbarkeitInfoComponent {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: Verfuegbarkeitsanfrage) {
    this.render();
  }

/**
 * Beschreibt Methode render und ihren Rückgabevertrag.
 */
  render() {
    const lieferung = false;
    if (this.data.status.Verfuegbarkeitsinformation) {
      this.data.status.Verfuegbarkeitsinformation.forEach(vi => {
        if (vi.LieferungMoeglich) {
          if (vi.InfoText == 'Teilmenge lagernd') {
            vi.color = 'orange2';
          } else {
            vi.color = 'green';
          }

        } else if (vi.InfoCode == 'BS') {
          vi.color = 'orange';

        } else {
          vi.color = 'red';
        }
      });
    }
  }

/**
 * Beschreibt Methode keydown und ihren Rückgabevertrag.
 */
  keydown(event) {
    event.stopPropagation();
  }
}
